<template>
  <div>
    <div class="content_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">待确认包裹</el-breadcrumb-item>
        <el-breadcrumb-item> 批次运单明细 </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content_box padding">
        <div class="content_box_title">
          <div class="circle_l"></div>
          <div class="circle_r"></div>
          <div class="text_xl">筛选查询</div>
        </div>
        <!-- 搜索筛选 -->
        <div>
          <div class="table_item_box">
            <div class="table_item_box_l">
              <div class="table_item_box_l_r">
                <div class="fill_in_title">运单号单号</div>

                <input
                  type="text"
                  placeholder="请输入单号"
                  class="table_item_input"
                />
              </div>
            </div>
            <div class="table_item_box_l">
              <div class="table_item_box_l_r">
                <div class="fill_in_title">国内运单号</div>

                <input
                  type="text"
                  placeholder="请输入国内运单号"
                  class="table_item_input"
                />
              </div>
            </div>

            <div
              class="table_item_box_s"
              style="flex-direction: column-reverse"
            >
              <div class="table_item_box_l_r"></div>
              <div class="table_item_box_l_s">
                <el-button type="primary" round class="round_btn"
                  >搜索</el-button
                >
                <el-button round>重置</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content_box ">
      <div class="content_box_ls">
        <div class="content_box_title">
          <div class="circle_l"></div>
          <div class="circle_r"></div>
          <div class="text_xl">
            批次号：0214-1-14多伦多到货-20210203运单明细
          </div>
        </div>
        <div class="content_box_title_r">
          <div class="text_l">总重量 5kg</div>
          <div class="text_l">包裹数 5</div>
          <div class="text_l">总运费 $890</div>
        </div>
      </div>

      <div class="table_box">
        <el-table
          :header-cell-style="{ background: '#E7EDF8', color: '#333333' }"
          :data="tableData"
          stripe
          style="width: 100%"
        >
          <el-table-column align="center" prop="dateCreated" label="创建日期">
          </el-table-column>
          <el-table-column align="center" prop="name" label="单号">
          </el-table-column>
          <el-table-column align="center" prop="weight" label="单号">
          </el-table-column>
          <el-table-column align="center" prop="recipientname" label="收件人">
          </el-table-column>
          <el-table-column align="center" prop="WeightKg" label="收费重量">
          </el-table-column>
          <el-table-column align="center" prop="ShippingCost" label="总运费">
          </el-table-column>
          <el-table-column align="center" prop="weight" label="总箱数">
          </el-table-column>
   
        
          <el-table-column align="center" label="详情">
            <template slot-scope="scope">
              <el-button type="text">查看物流</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    data(){
        return{
             tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
          weight: "80",
        },
        {
          date: "2016-05-04",
          weight: "80kg",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          date: "2016-05-01",
          weight: "80kg",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
        },
        {
          date: "2016-05-03",
          weight: "80kg",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄",
        },
      ],
        }
    }
};
</script>
<style scoped>
.content_box {
  width: 100%;
  height: auto;
  background: #ffffff;
  padding: 38px 30px;
  margin-bottom: 12px;
  box-sizing: border-box;
}
.content_box_title_r {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.content_box_ls {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.padding {
  padding: 38px 0 !important;
}
.table_item_box_l_s .el-button.is-round {
  border-radius: 14px;
  width: 110px;
  height: 40px;
}
.table_item_box_s {
  display: flex;
}
.table_item_box_l_s {
  display: flex;
}
.table_item_input >>> .el-input__inner {
  background: none !important;
  outline: none !important;

  border: none;
  color: #fff !important;
  padding: 0;
}
.fill_in_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-right: 9px;
}
.table_item_box {
  display: flex;
  /* align-items: flex-end; */

  flex-wrap: wrap;
  padding: 25px 30px 0;
  box-sizing: border-box;
}
.table_item_box_l_r {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}
.table_item_input {
  width: 180px;
  height: 40px;
  background: #ffffff;

  border: 1px solid #dedede;
  opacity: 1;
  border-radius: 10px;
  margin-left: 10px;
  padding: 0 15px !important;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.table_item_box_l {
  margin-right: 30px;
  text-align: left;
}
.text_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 21px;
  color: #333333;
  margin-left: 45px;
}
.table_box {
  margin-top: 32px;
}
</style>


// WEBPACK FOOTER //
// src/views/undetermined/batchDetail.vue